import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

/** 예비창업 자격 진단(specs/072) — 비로그인 공개, 미니멀 레이아웃(체험과 같다). */
export const diagnosisRoutes: RouteObject[] = [
  {
    path: 'diagnosis',
    lazy: () => import('./pages/DiagnosisPage').then((m) => ({ Component: m.DiagnosisPage })),
    handle: { title: '예비창업 자격 진단', pageLabel: '예비창업 진단' } satisfies RouteHandle,
  },
];
